export default __webpack_public_path__ + "static/media/013-flag.89967df3.svg";